import type { SwapOrderDto } from '../lib/swap';
import type { TransferDto } from '../lib/transfers';

function normAddr(chain: string, addr: string): string {
  return chain === 'eth' || chain === 'bsc' || chain === 'hyperevm' ? addr.toLowerCase() : addr;
}

/** Hide the outbound deposit transfer that funds a swap (linked id or payin match). */
export function isSwapDepositTransfer(tr: TransferDto, orders: SwapOrderDto[]): boolean {
  if (tr.direction !== 'out') return false;
  for (const o of orders) {
    if (o.depositTransferId && o.depositTransferId === tr.id) return true;
    if (
      o.payinAddress &&
      o.fromChain === tr.chain &&
      o.fromToken === tr.token &&
      normAddr(tr.chain, o.payinAddress) === normAddr(tr.chain, tr.toAddress)
    ) {
      return true;
    }
  }
  return false;
}

/** Tx hash of the hidden payin deposit, so the swap row can link the explorer. */
export function swapDepositTxHash(
  order: SwapOrderDto,
  transfers: Pick<TransferDto, 'id' | 'txHash'>[],
): string | null {
  if (!order.depositTransferId) return null;
  return transfers.find((t) => t.id === order.depositTransferId)?.txHash ?? null;
}
